import contact from './lib/contact'
import rebox from './lib/rebox'
import { toggleBelowFold, scrollSpy, smoothScroll } from './lib/scroll'

import { Splide } from '@splidejs/splide'

$(document).ready(function () {
  contact('#contact-form')
  rebox('.instanode-headstart-thumbimage')
  toggleBelowFold()
  // scrollSpy('.header-nav-sub:visible', {offset: 0})
  // smoothScroll('a[href^="#"]', {offset: 0})
})
document.addEventListener('DOMContentLoaded', function () {
  const elementIconSlider = document.querySelector('.information-slider')
  if (elementIconSlider) {
    console.log('Element gefunden:', elementIconSlider)
    const splide = new Splide('.splide.information', {
      perPage: 2,
      perMove: 2,
      gap: 20,
      mediaQuery: 'max',
      breakpoints: {
        1024: {
          perPage: 2,
          perMove: 2,
          padding: '2rem',
          gap: 33
        },
        500: {
          padding: '1rem'
        }
      }
    })
    splide.mount()
  } else {
    console.log('Kein Element mit der Klasse "information" gefunden.')
  }
})

$(document).ready(function () {
  // Add or remove class 'active' to/from sections based on scroll position
  const allContainer = document.querySelectorAll('.grid-content')

  window.onscroll = function () {
    allContainer.forEach(section => {
      const rect = section.getBoundingClientRect()
      if (rect.top <= 800 && rect.bottom > 0) {
        // Add 'active' if the section is in the viewport
        section.classList.add('active')
      } else {
        // Remove 'active' if the section is out of the viewport
        section.classList.remove('active')
      }
    })
  }
})

document.addEventListener('DOMContentLoaded', function () {
  // Mapping von Font-Weight-Bezeichnern zu numerischen Werten
  const fontWeightMap = {
    thin: 100,
    extralight: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800
  }

  // Liste der CSS Custom Properties, die ersetzt werden sollen
  const variablesToReplace = [
    '--body-text-font-weight',
    '--headline-one-font-weight',
    '--headline-two-font-weight',
    '--headline-three-font-weight',
    '--headline-four-font-weight'
  ]

  // Alle <style>-Tags im <head> holen
  const styleTags = document.head.querySelectorAll('style')

  // Durch alle <style>-Tags iterieren
  for (let i = 0; i < styleTags.length; i++) {
    const styleTag = styleTags[i]
    const cssContent = styleTag.textContent

    // Suchen nach dem body-Block
    const bodyRuleMatch = cssContent.match(/body\s*\{([^}]+)\}/)

    if (bodyRuleMatch) {
      let bodyStyles = bodyRuleMatch[1]

      // Jede Variable prüfen und ggf. ersetzen
      for (let j = 0; j < variablesToReplace.length; j++) {
        const variable = variablesToReplace[j]

        // RegEx um den Wert der CSS-Variable zu finden
        const regex = new RegExp(variable + '\\s*:\\s*([^;]+);?')
        const match = bodyStyles.match(regex)

        if (match) {
          const keyword = match[1].trim().toLowerCase()
          const numericValue = fontWeightMap[keyword] || 400

          // Variable im CSS ersetzen
          const replacement = variable + ': ' + numericValue + ';'
          bodyStyles = bodyStyles.replace(regex, replacement)
        }
      }

      // Den aktualisierten body-Block im gesamten CSS ersetzen
      const updatedCss = cssContent.replace(/body\s*\{[^}]+\}/, 'body {' + bodyStyles + '}')

      // Zurückschreiben in das <style>-Tag
      styleTag.textContent = updatedCss

      // Nur das erste relevante <style>-Tag bearbeiten
      break
    }
  }
})

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header')
  const navItems = header.querySelectorAll('.header-nav-list > li')
  let activeItem = null

  navItems.forEach(item => {
    item.addEventListener('mouseenter', () => {
      if (activeItem && activeItem !== item) {
        activeItem.classList.remove('is-open')
      }
      if (item.querySelector('.second-level-sub-navigation')) {
        item.classList.add('is-open')
        activeItem = item
      }
    })

    item.addEventListener('mouseleave', (e) => {
      const toElement = e.relatedTarget
      if (!header.contains(toElement)) {
        item.classList.remove('is-open')
        activeItem = null
      }
    })
  })

  header.addEventListener('mouseleave', () => {
    if (activeItem) {
      activeItem.classList.remove('is-open')
      activeItem = null
    }
  })
})

document.addEventListener('DOMContentLoaded', function () {

  const mobileDropdowns = document.querySelectorAll('.dropdown-mobile');

  // 1. mobile-parent-link (innerer echter Link) darf nicht verhindern, darf aber kein Dropdown öffnen
  document.querySelectorAll('.mobile-parent-link a').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.stopPropagation(); // Klick bleibt in der Ebene
    });
  });

  // 2. Dropdown öffnen/schließen
  mobileDropdowns.forEach(function (item) {

    // Der Klick soll NICHT hochwandern zu anderen dropdown-mobile
    item.addEventListener('click', function (e) {

      if (window.innerWidth >= 1200) return;

      // Wenn ein echter Link im Dropdown geklickt wurde → Dropdown NICHT toggeln
      if (e.target.closest("a") && !e.target.closest(".level1-link")) {
        e.stopPropagation();
        return;
      }

      // verhindern, dass der Klick Eltern-Dropdowns triggert
      e.stopPropagation();

      // Level-1-Link (der deaktivierte) soll nicht navigieren
      if (e.target.closest(".level1-link")) {
        e.preventDefault();
      }

      // Toggle nur auf diesem Element
      item.classList.toggle('open');
    });
  });

  // 3. body klick soll andere dropdowns NICHT schließen
  //    wir schließen nur, wenn du das willst – aktuell nicht nötig
});